import React from 'react';

const DemoHeader = () => {
  return (
    <div className="demoHeader">
      <span className="demoHeaderText">Follow the steps below, to demo the app...</span>
    </div>
  );
};

export default DemoHeader;